import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useGlobalContext } from "../../context";
import { useLocation, Link } from "react-router-dom";
import FadeOnScreen from "../../utils/fadeOnScreen";
import localData from "../../localData";
import { Button } from "../../components";

export default function Blog() {
    const { fade } = useGlobalContext().animations;

    const location = useLocation();

    useEffect(() => FadeOnScreen.createObserver(), [location]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { blogPage1, blogPage2, blogPage3, blogPage4, blogPage5, blogPage6 } = localData.images;
    return (
        <motion.main {...fade} className="blog-page">
            <section className="showcase">
                <div className="container">
                    <div className="showcase-center">
                        <div className="card blog-card" data-lazy-block>
                            <div className="card-image" data-lazy="fade-right">
                                <img src={blogPage1} alt="" />
                            </div>
                            <h4 className="card-title" data-lazy="fade">
                                {" "}
                                BRANDING TIPS FOR STARTUPS
                            </h4>
                        </div>
                        <div className="card blog-card" data-lazy-block>
                            <div className="card-image" data-lazy="fade-right">
                                <img src={blogPage2} alt="" />
                            </div>
                            <h4 className="card-title" data-lazy="fade">
                                10 IMPORTANCE OF BRANDING{" "}
                            </h4>
                        </div>
                        <div className="card blog-card" data-lazy-block>
                            <div className="card-image" data-lazy="fade-right">
                                <img src={blogPage3} alt="" />
                            </div>
                            <h4 className="card-title" data-lazy="fade">
                                THIS BRAND STORY WILL TEACH YOU ALOT
                            </h4>
                        </div>
                        <div className="card blog-card" data-lazy-block>
                            <div className="card-image" data-lazy="fade-right">
                                <img src={blogPage4} alt="" />
                            </div>
                            <h4 className="card-title" data-lazy="fade">
                                WHY BRAND STRATEGY IS CRUCIAL
                            </h4>
                        </div>
                        <div className="card blog-card" data-lazy-block>
                            <div className="card-image" data-lazy="fade-right">
                                <img src={blogPage5} alt="" />
                            </div>
                            <h4 className="card-title" data-lazy="fade">
                                HOW TO SET UP A WORKING USER PERSONA
                            </h4>
                        </div>
                        <div className="card blog-card" data-lazy-block>
                            <div className="card-image" data-lazy="fade-right">
                                <img src={blogPage6} alt="" />
                            </div>
                            <h4 className="card-title" data-lazy="fade">
                                HOW TO BUILD A USER CENTERED BRAND
                            </h4>
                        </div>
                    </div>

                    <div className="wrapper contact-btn-wrapper">
                        <Link to="/contact">
                            <Button className="btn btn-lg btn-outline-light contact-btn">
                                <p>start a conversation</p>
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>
        </motion.main>
    );
}
